export const navToExternalUrl = (event, url) => {
  event?.preventDefault();
  window.open(url, '_blank');
}

export const getPlatform = (): string => {
  const userAgent = navigator.userAgent || navigator.vendor;

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return 'iOS';
  }

  if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
    return 'Mac';
  }

  if (/Win32|Win64|Windows|WinCE/.test(userAgent)) {
    return 'Windows';
  }

  return 'Other';
}

/**
 * Maps language codes to proper locale codes for date formatting
 * @param lang - Language code (e.g., 'en', 'uk')
 * @returns Locale code (e.g., 'en-US', 'uk-UA')
 */
export const getLocaleFromLang = (lang: string): string => {
  const localeMap: { [key: string]: string } = {
    'en': 'en-US',
    'uk': 'uk-UA'
  };
  return localeMap[lang] || 'en-US';
}

/**
 * Formats a date using the specified locale
 * @param date - The date to format
 * @param locale - The locale code (e.g., 'en-US', 'uk-UA')
 * @param options - Intl.DateTimeFormat options (defaults to short date and time)
 * @returns Formatted date string
 */
export const formatDate = (
  date: Date | string | undefined | null,
  locale: string = 'en-US',
  options?: Intl.DateTimeFormatOptions
): string => {
  if (!date) return '';

  const dateObj = typeof date === 'string' ? new Date(date) : date;

  const defaultOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  };

  return new Intl.DateTimeFormat(locale, options || defaultOptions).format(dateObj);
}

